export const messages = {
    "wr-dashboard.search.input.hint": "Keresés",
    "wr-dashboard.search.label.breadcrumb": "Találatok",
    "wr-dashboard.search.message.empty": "Nincs a keresési feltételeknek megfelelő elem",
    "wr-dashboard.side-bar.selected.title:plural": "{count} elem kiválasztva | {count} elem kiválasztva | {count} elem kiválasztva",
    "wr-dashboard.side-bar.backup-type.disk": "Lemez",
    "wr-dashboard.side-bar.backup-type.file": "Fájl",
    "wr-dashboard.side-bar.backup-type.notarized": "Közjegyzőileg hitelesített fájlok és mappák",
    "wr-dashboard.side-bar.backup-type.exchange": "Alkalmazás: Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "Alkalmazás: Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "Alkalmazás: Rendszer állapota",
    "wr-dashboard.side-bar.backup-type.application": "Alkalmazás",
    "wr-dashboard.backups-table.column.name": "Név",
    "wr-dashboard.backups-table.column.size": "Méret",
    "wr-dashboard.backups-table.column.version": "Legutóbbi verzió",
    "wr-dashboard.backups-table.action.delete": "Törlés",
    "wr-dashboard.backups-table.message.no-backups": "Még nincsenek biztonsági másolatok a felhőben",
    "wr-dashboard.backups-sidebar.label.size": "Méret",
    "wr-dashboard.backups-sidebar.label.type": "Típus",
    "wr-dashboard.backups-sidebar.label.version": "Legutóbbi verzió",
    "wr-dashboard.backups-sidebar.label.created": "Létrehozva",
    "wr-dashboard.backups-sidebar.label.machine": "Gép",
    "wr-dashboard.backups-sidebar.label.owner": "Tulajdonos",
    "wr-dashboard.content-table.column.name": "Név",
    "wr-dashboard.content-table.column.versions": "Verziók",
    "wr-dashboard.content-table.column.volumes": "Kötetek",
    "wr-dashboard.content-table.column.path": "Elérési út",
    "wr-dashboard.content-table.column.size": "Méret",
    "wr-dashboard.content-table.column.version": "Legutóbbi verzió",
    "wr-dashboard.content-table.action.notary-verify": "Ellenőrzés",
    "wr-dashboard.content-table.action.notary-get-crt": "Tanúsítvány beszerzése",
    "wr-dashboard.content-table.action.asign": "Elküldés aláírásra",
    "wr-dashboard.content-table.action.versions": "Verziók",
    "wr-dashboard.content-table.action.restore": "Letöltés",
    "wr-dashboard.content-table.label.size": "Méret",
    "wr-dashboard.content-table.label.created": "Létrehozva",
    "wr-dashboard.content-table.label.modified": "Módosítva",
    "wr-dashboard.content-table.message.empty-folder": "Ez a mappa üres",
    "wr-dashboard.password-dialog-box.title.backup": "Titkosított biztonsági másolat",
    "wr-dashboard.password-dialog-box.title.archive": "Titkosított archívum",
    "wr-dashboard.password-dialog-box.message.backup": "Adja meg a jelszót a(z) {displayName} biztonsági másolat eléréséhez",
    "wr-dashboard.password-dialog-box.message.archive": "Adja meg a jelszót a(z) {displayName} archívum eléréséhez",
    "wr-dashboard.password-dialog-box.hint.password": "Jelszó",
    "wr-dashboard.password-dialog-box.message.invalid-password": "A jelszó helytelen",
    "wr-dashboard.form.button.open": "Megnyitás",
    "wr-dashboard.form.button.close": "Bezárás",
    "wr-dashboard.form.button.cancel": "Mégse",
    "wr-dashboard.form.button.continue": "Folytatás",
    "wr-dashboard.form.button.proceed": "Tovább",
    "wr-dashboard.form.button.delete": "Törlés",
    "wr-dashboard.form.button.done": "Kész",
    "wr-dashboard.form.button.retry": "Újra",
    "wr-dashboard.notary.verify.view.status.downloading": "Letöltés folyamatban…",
    "wr-dashboard.notary.verify.view.status.validating": "Érvényesítés...",
    "wr-dashboard.notary.verify.view.status.pending": "Tanúsítvány kiadása folyamatban...",
    "wr-dashboard.notary.verify.view.status.fail": "Nem egyező tanúsítványok...",
    "wr-dashboard.notary.verify.view.button.get-crt": "Tanúsítvány beszerzése",
    "wr-dashboard.notary.verify.view.file-info.name": "NÉV",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "ALÁÍRTA",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "BIZTONSÁGI MENTÉS DÁTUMA",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "KÖZJEGYZŐI HITELESÍTÉS DÁTUMA",
    "wr-dashboard.notary.verify.view.button.cancel": "Mégse",
    "wr-dashboard.notary.verify.view.button.done": "Kész",
    "wr-dashboard.notary.warning.unsupported.browser.version": "Nem támogatott böngésző-verzió",
    "wr-dashboard.versions-dialog-box.title": "{fileName} verziói",
    "wr-dashboard.asign-dialog-box.title": "Elküldés aláírásra",
    "wr-dashboard.asign-dialog-box.message": "A fájlverzió meg van osztva, de senki sem tudja megtekinteni a fájl az arra mutató hivatkozás nélkül. Továbblépés az ASignra aláírások hozzáadásához és a hivatkozás megosztásához.",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "Fájlrészletek megjelenítése",
    "wr-dashboard.page-not-found.title": "Nem találjuk az oldalt",
    "wr-dashboard.page-not-found.message.main": "Nem található a keresett oldal.",
    "wr-dashboard.page-not-found.message.description": "Lehet, hogy elavult a hivatkozás, esetleg rosszul írta be a címet.",
    "wr-dashboard.page-not-found.message.error": "Hibakód: 404",
    "wr-dashboard.server-error.title": "A kiszolgáló nem érhető el",
    "wr-dashboard.server-error.message": "A kiszolgáló jelenleg nem érhető el. Próbálkozzon újra később.",
    "wr-dashboard.server-error.message.error": "Hibakód: 500",
    "wr-dashboard.account-menu.action.sign-out": "Kijelentkezés",
    "wr-dashboard.breadcrumb.item.machines": "Gépek",
    "wr-dashboard.breadcrumb.item.failed-backups": "Hibás biztonsági másolatok",
    "wr-dashboard.machines-table.column.name": "Név",
    "wr-dashboard.machines-table.column.size": "Méret",
    "wr-dashboard.machines-table.message.no-machines": "Még nincsenek gépek a felhőben",
    "wr-dashboard.incomplete-backups.message.status:plural": "{count} hibás vagy hiányos biztonsági másolatot találtunk. {size} tárterületet foglalnak el. | {count} hibás vagy hiányos biztonsági másolatot találtunk. {size} tárterületet foglal el. | {count} hibás vagy hiányos biztonsági másolatot találtunk. {size} tárterületet foglalnak el.",
    "wr-dashboard.incomplete-backups.button.view": "Biztonsági másolatok megtekintése",
    "wr-dashboard.incomplete-backups.button.delete": "Biztonsági másolatok törlése",
    "wr-dashboard.machines-table.message.space-used:plural": "Biztonsági másolatok összesített mérete: {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "Archívumok törlése",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "Befejezetlen archívumok törlése",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "Az összes befejezetlen archívum törlése",
    "wr-dashboard.delete-archive.message": "Biztos, hogy végleg törli a kijelölt archívumokat az összes helyről? Ha így tesz, minden adat törlődni fog, és nem lehet őket visszaállítani.",
    "wr-dashboard.delete-archive.deletion-warning-message": "Előfordulhat, hogy az ebben a webes visszaállítási konzolban végrehajtott módosítások a védelmi konzol megfelelő gépén nem jelennek meg, ha a gép vagy a módosításokat feldolgozó ügynökök kapcsolat nélküli üzemmódban vannak.",
    "wr-dashboard.delete-archive.locked-error-message": "Az adatok konzisztenciája érdekében zároltuk az archívumot. Állítsa le az archívummal kapcsolatos összes műveletet (például tallózást, visszaállítást vagy biztonsági mentést), és próbálkozzon újra.",
    "wr-dashboard.certificate-pending-dialog-box.title": "Tanúsítvány függőben",
    "wr-dashboard.certificate-pending-dialog-box.message": "Próbálkozzon újra néhány perc múlva.",
    "wr-dashboard.form.button.ok": "OK"
};
